import { disableBodyScroll, enableBodyScroll } from "../utils";

const LG_BREAKPOINT = 1024;

export default class Menu {
  constructor() {
    this.isMobile = false;
    this.open = false;
    this.$toggle = document.querySelectorAll(".js-toggle-mobile-menu");
    this.$panel = document.querySelector(".js-menu-panel");

    this.checkWidth();

    window.addEventListener("resize", this.checkWidth.bind(this));

    this.$toggle.forEach(($toggle) => {
      this.setupToggle($toggle);
    });
  }

  checkWidth() {
    if (window.innerWidth < LG_BREAKPOINT) {
      this.isMobile = true;
    } else {
      this.isMobile = false;
    }
  }

  setupToggle($toggle) {
    $toggle.addEventListener("click", () => {
      this.toggleMenu();
    });
  }

  toggleMenu() {
    if (this.isMobile) {
      if (!this.open) {
        this.$panel.classList.remove("translate-x-full");
        disableBodyScroll();
      } else {
        this.$panel.classList.add("translate-x-full");
        enableBodyScroll();
      }
      this.open = !this.open;
    }
  }
}
